interface EmailTemplate {
  id: string;
  name: string;
  description: string;
  structure: {
    sections: Array<{
      id: string;
      name: string;
      required: boolean;
      defaultContent?: string;
    }>;
  };
}

export const emailTemplates: EmailTemplate[] = [
  {
    id: 'vehicle-promotion',
    name: 'Vehicle Promotion',
    description: 'Standard template for promoting vehicles with special offers',
    structure: {
      sections: [
        {
          id: 'greeting',
          name: 'Greetings',
          required: true,
        },
        {
          id: 'dealership-info',
          name: 'Dealership Information',
          required: true,
        },
        {
          id: 'vehicle-details',
          name: 'Vehicle Details',
          required: true,
        },
        {
          id: 'offer-details',
          name: 'Special Offer',
          required: true,
        },
        {
          id: 'maintenance-services',
          name: 'Maintenance & Services',
          required: false,
        },
        {
          id: 'call-to-action',
          name: 'Call to Action',
          required: true,
          defaultContent: `We invite you to visit our dealership to experience this vehicle in person.

Our team is ready to assist you with:
- Detailed vehicle information
- Test drive scheduling
- Financing options
- Trade-in valuation

Contact us today to learn more about this exclusive offer!`
        }
      ]
    }
  },
  {
    id: 'service-reminder',
    name: 'Service Reminder',
    description: 'Template for service reminders and maintenance promotions',
    structure: {
      sections: [
        {
          id: 'dealership-info',
          name: 'Dealership Information',
          required: true,
        },
        {
          id: 'service-type',
          name: 'Service Type',
          required: true,
        },
        {
          id: 'service-benefits',
          name: 'Service Benefits',
          required: true,
        },
        {
          id: 'pricing-details',
          name: 'Pricing Details',
          required: false,
        },
        {
          id: 'call-to-action',
          name: 'Call to Action',
          required: true,
          defaultContent: 'Schedule your service appointment today!'
        }
      ]
    }
  },
  {
    id: 'follow-up',
    name: 'Follow-up Email',
    description: 'Template for following up with potential customers after initial contact',
    structure: {
      sections: [
        {
          id: 'greeting',
          name: 'Greeting',
          required: true,
          defaultContent: 'Dear [Customer Name],'
        },
        {
          id: 'introduction',
          name: 'Introduction',
          required: true,
          defaultContent: 'Thank you for your recent interest in our vehicles.'
        },
        {
          id: 'vehicle-details',
          name: 'Vehicle Details',
          required: true
        },
        {
          id: 'offer-details',
          name: 'Offer Details',
          required: false
        },
        {
          id: 'call-to-action',
          name: 'Call to Action',
          required: true,
          defaultContent: 'Please don\'t hesitate to contact us for more information or to schedule a test drive.'
        },
        {
          id: 'closing',
          name: 'Closing',
          required: true,
          defaultContent: 'Best regards,'
        }
      ]
    }
  },
  {
    id: 'inventory-update',
    name: 'Inventory Update',
    description: 'Template for sharing new inventory and special offers with customers',
    structure: {
      sections: [
        {
          id: 'greeting',
          name: 'Greeting',
          required: true,
          defaultContent: 'Dear [Customer Name],'
        },
        {
          id: 'introduction',
          name: 'Introduction',
          required: true,
          defaultContent: 'We\'re excited to share our latest inventory updates with you.'
        },
        {
          id: 'new-arrivals',
          name: 'New Arrivals',
          required: true
        },
        {
          id: 'featured-vehicles',
          name: 'Featured Vehicles',
          required: true
        },
        {
          id: 'special-offers',
          name: 'Special Offers',
          required: false
        },
        {
          id: 'closing',
          name: 'Closing',
          required: true,
          defaultContent: 'Best regards,'
        }
      ]
    }
  }
]; 